import { createReducer } from "@reduxjs/toolkit";
import {
  loadingSession,
  loadSessionFailed,
  loggedInUser,
  loggedOutUser,
  loggingInUser,
  loginFailed,
  sessionLoaded,
  userSessionExpired,
} from "core/redux/actions/user/userActions";

import type { UserState } from "./userReducer.types";

const initialState: UserState = {
  loggingIn: false,
  loginFailed: false,
  loadingSession: false,
  sessionExpired: false,
};

const userReducer = () =>
  createReducer(initialState, (builder) =>
    builder

      .addCase(loggingInUser, () => ({
        loggingIn: true,
        loginFailed: false,
        loadingSession: false,
        session: undefined,
        sessionExpired: undefined,
      }))

      .addCase(loginFailed, () => ({
        loggingIn: false,
        loginFailed: true,
        loadingSession: false,
        session: undefined,
        sessionExpired: undefined,
      }))

      .addCase(loggedInUser, (state, action) => ({
        loggingIn: false,
        loginFailed: false,
        loadingSession: false,
        session: action.payload.appState?.session,
        sessionExpired: false,
      }))

      .addCase(sessionLoaded, (state, action) => ({
        loggingIn: false,
        loginFailed: false,
        loadingSession: false,
        session: action.payload.appState.session,
        sessionExpired: undefined,
      }))

      .addCase(loadingSession, () => ({
        loggingIn: false,
        loginFailed: false,
        loadingSession: true,
        session: undefined,
        sessionExpired: undefined,
      }))

      .addCase(loadSessionFailed, () => ({
        loggingIn: false,
        loginFailed: false,
        loadingSession: false,
        session: undefined,
        sessionExpired: undefined,
      }))

      .addCase(userSessionExpired, (state) => ({
        ...state,
        sessionExpired: true,
      }))

      .addCase(loggedOutUser, () => ({
        ...initialState,
        initAppAfterLogOut: true,
      }))
  );

export default userReducer;
